import { getEnv } from 'swisscard/helpers/env'

const apiHost = getEnv('API_HOST') || ''

export const apiGetWebForm = `${apiHost}/api/web_forms/\${id}`
export const apiSubmitWebForm = `${apiHost}/api/web_forms/\${id}`

export const cybwellToken = `${apiHost}/api/address_token`
export const cybwellAddressSuggest =
  'https://webservice.cybwell.ch/onboarding/suggestadress.ashx?clientIP=valiant&style=JSON&q=${query}&callback=dog&SOURCE=CYB-A-ENGINE&token=${token}'
export const cybwellAddressDetail =
  'https://webservice.cybwell.ch/onboarding/getAdressDetail.ashx?clientIP=valiant&style=JSON&legacyid=${legacyId}&callback=dog&token=${token}'
